module.exports = __webpack_public_path__ + "img/1N.1.cc423775.jpg";